<h5>{{ 'izs.title' | translate }}</h5>
<base-customer-izs-widget
  *ngIf="!!pdlId; else noIzs"
  class="d-block h-100"
  [pdlId]="pdlId"
></base-customer-izs-widget>

<ng-template #noIzs>
  <base-empty-list-row
    [backgroundSecondary]="true"
    message="izs.noData"
  ></base-empty-list-row>
</ng-template>
